/**
 * Common attributes for non-interactive Suspense fallback skeletons.
 */
export const SKELETON_PROPS = {
  'aria-hidden': 'true',
  'data-skeleton': ''
};
